exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.second-customer-modal[data-v-7605a980] {\n  position: absolute;\n  width: 350px;\n  z-index: 99;\n  background-color: #ffffff;\n  top: 30px;\n  float: right;\n  border: 1px solid #d2d2d4;\n  border-radius: 5px;\n  padding: 15px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7605a980","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/jobs/modals/SecondCustomerInfo.vue
// module id = kcl2
// module chunks = 0